// ==== EVENT CATEGORIES ====
// Event category should describe a type of page, a part of 
// a page or type of the module in which an event occurred.
// Format: {{Page type}}. E.g. Vessel-List

// ==== EVENT ACTIONS ====
// Naming of an event action should be structured in the 
// way to describe which action has been taken and where it was taken
// Format: {{Action}} {{Action Location}}. E.g. Clicked Save-and-Close

// ==== EVENT LABELS ====
// Event label names should describe specific information relating 
// to an event. Can choose text more freely.
// Format: {{Extra Info}}. E.g. IMO Number

// ==== EVENT VALUE ====
// Value is a number signifying the perceived value of an action. This 
// is not used in FI app

export abstract class TraceServiceBase
{
    abstract pageView(path: string, title?: string): void;
    abstract event(category: string, action: string, label?: string, value?: number): void;
}

let TraceService: TraceServiceBase|null = null;

function setTraceService(service: TraceServiceBase)
{
    TraceService = service;
}

export { TraceService, setTraceService };

export const EVENT_CATEGORIES = {
    TIME_CONTROL: "Voyage-Time-Control",
    TOPBAR: "Voyage-Topbar",
    VESSEL_LIST: "Voyage-Vessel-List",
    WEATHER_CONTROL: "Voyage-Weather-Control",
    SHORE_MAIN_APP: "Voyage-Shore-App",
    VESSEL_MAIN_APP: "Voyage-Vessel-App",
    ROUTE_IMPORT_EXPORT: "Voyage-Route-Import-Export",
};

// CATEGORIES
export const FI_EVENT_CATEGORIES = {
    VESSEL_LIST: "Vessel List",
    VESSEL_DETAILS: "Vessel Details",
    MAP_INTERACTIONS: "Map Interactions"
}

// ACTIONS
export const FI_VESSEL_DETAILS_ACTIONS = {
    CLICKED_PORT_VIEW: "Clicked Port View",
    CLICKED_ALARMS: "Clicked Alarms",
    CLICKED_DIVERT_TO: "Clicked Divert To",
    CLICKED_SCHEDULE: "Clicked Schedule",
    CLICKED_VESSEL_ENERGY: "Clicked Vessel Energy",
    CLICKED_PAST_TRAIL: "Clicked Past Trail",
    CLICKED_PERFORMANCE: "Clicked Performance"
}

export const FI_VESSEL_LIST_ACTIONS = {
    SELECTED_VESSEL: "Selected Vessel",
}

export const MAP_INTERACTIONS = {
    SELECTED_VESSEL: "Selected Vessel",
}
